import React, { useEffect, useState } from 'react';
import DynamicNavBar from "../../Component/navbars/navbar";
import { MdOutlineBlock, MdOutlineVerifiedUser } from "react-icons/md";
import { IoIosAddCircleOutline } from "react-icons/io";
import apiRequests from "../../Component/axios/config/config";
import toast from 'react-hot-toast';
import { FaUserCheck } from "react-icons/fa";


export default function Users() {
    const [users, setUsers] = useState([]);
    const [errorMsg, setErrorMsg] = useState('');
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [add, setAdd] = useState(false)
    const [showEditModal, setShowEditModal] = useState(false);
    const [newNumber, setNewNumber] = useState('');
    const [loadingEdit, setLoadingEdit] = useState(false);

    const [typeUser, setTypeUser] = useState("all");

    const items = [
        { icon: <IoIosAddCircleOutline />, label: "افزودن", func: showModalAdd },
        { icon: <FaUserCheck />, label: "همه کاربران", value: "all", status: typeUser,func: () => setTypeUser("all")  },
        { icon: <MdOutlineVerifiedUser />, label: "کاربران فعال", value: "active", status: typeUser, func: () => setTypeUser("active") },
        { icon: <MdOutlineBlock />, label: "کاربران غیر فعال" , value: "block", status: typeUser, func: () => setTypeUser("block")},
    ];

    const apiLogin = () => {
        setLoading(true);
        apiRequests.get("/api/user/v1/get-usersList-by-admin")
            .then((res) => {
                setUsers(res.data.data);
            })
            .catch(() => { })
            .finally(() => setLoading(false));
    };



    function showModalAdd() {
        setSelectedUser(null);
        setNewNumber('');
        setAdd(true)
    }
    function addUser() {
        const full_name = selectedUser?.full_name?.trim();
        const national_code = selectedUser?.national_code?.trim();
        const mobile = newNumber.trim();

        if (!full_name) {
            toast.error("نام و نام خانوادگی الزامی است.");
            return;
        }

        if (!/^09\d{9}$/.test(mobile)) {
            toast.error("شماره تلفن معتبر نیست.");
            return;
        }

        if (!/^\d{10}$/.test(national_code)) {
            toast.error("کد ملی معتبر نیست!")
            return;
        }

        setLoadingEdit(true);

        apiRequests.post("/api/user/v1/register-user", {
            full_name,
            mobile,
            national_code,
        })
            .then(() => {
                setAdd('');
                setNewNumber('');
                setSelectedUser(null);
                apiLogin();
                toast.success("کاربر جدید با موفقیت وارد شد")
            })
            .catch((err) => {
                console.log(err)
                console.error("❌ خطا در افزودن کاربر:", err);

            })
            .finally(() => setLoadingEdit(false));
    }


    const handleDeleteClick = (user) => {
        setSelectedUser(user);
        setShowModal(true);
    };

    const confirmDelete = () => {
        if (!selectedUser) return;
        setLoadingDelete(true);
        apiRequests.delete("/api/user/v1/delete-user-admin", {
            data: { userId: selectedUser._id }
        })
            .then(() => {
                setShowModal(false);
                setSelectedUser(null);
                apiLogin();
                toast.success("کاربر با موفقیت حذف شد.")
            })
            .catch(() => { })
            .finally(() => setLoadingDelete(false));
    };

    const handleEditClick = (user) => {
        setSelectedUser(user);
        setNewNumber(user.mobile || '');
        setShowEditModal(true);
    };

    const confirmEdit = () => {

        if (!selectedUser || !newNumber) return;

        setLoadingEdit(true);

        apiRequests.put("/api/user/v1/change-phone-number-by-admin", {
            newNumber: newNumber,
            oldNumber: selectedUser.mobile
        })
            .then(() => {
                setShowEditModal(false);
                setSelectedUser(null);
                setNewNumber('');
                apiLogin();
                toast.success("کاربر با موفقیت ویرایش شد.")
            })
            .catch((err) => {

            })
            .finally(() => setLoadingEdit(false));
    };


    useEffect(() => {
        apiLogin();
    }, []);



    return (
        <div>
            <div className="px-6 text-3xl text-right md:mt-2  ">کاربران</div>
            <div className="md:flex md:justify-center">
                <DynamicNavBar items={items}   />

            </div>

            <div className="flex justify-center mt-8 ">
                <table className="min-w-[80%] mb-6 md:w-[90%]">
                    <thead className="bg-secondColor-shade4 text-white text-center">
                        <tr>
                            <th className="px-4 py-2 text-md md:text-[8px] font-medium rounded-tr-lg">نام و نام خانوادگی</th>
                            <th className="px-4 py-2 text-md md:text-[8px] font-medium">شماره تلفن</th>
                            <th className="px-4 py-2 text-md md:text-[8px] font-medium">وضعیت</th>
                            <th className="px-4 py-2 text-md md:text-[8px] font-medium rounded-tl-lg">عملیات</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {loading ? (
                            <tr className="text-center">
                                <td colSpan="4" className="py-6 text-blue-600 font-medium">
                                    درحال بارگیری...
                                </td>
                            </tr>
                        ) : users.length > 0 ? (
                            users.map((user, index) => (
                                <tr key={index} className="hover:bg-gray-100 md:text-[8px]  text-center">
                                    <td className="px-4 py-2">{user.full_name || "نام ثبت نشده"}</td>
                                    <td className="px-4 py-2">{user.mobile || "شماره ثبت نشده"}</td>
                                    <td className="px-4 py-2">
                                        {user.isActive ? (
                                            <span className="text-green-600 font-semibold">فعال</span>
                                        ) : (
                                            <span className="text-red-600 font-semibold">غیرفعال</span>
                                        )}
                                    </td>
                                    <td className="px-4 py-2 flex gap-3 justify-center">
                                        <button className="text-blue-600 hover:underline" onClick={() => handleEditClick(user)}>ویرایش</button>
                                        /
                                        <button className="text-red-600 hover:underline" onClick={() => handleDeleteClick(user)}>حذف</button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr className="text-center">
                                <td colSpan="4" className="py-6">
                                    {errorMsg || "کاربرانی یافت نشد!"}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Modal حذف */}
            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-6 w-96 text-center shadow-lg">
                        <p className="mb-6">آیا می‌خواهید کاربر {selectedUser?.full_name || "نامشخص"} را حذف کنید؟</p>
                        <div className="flex justify-around">
                            <button
                                onClick={confirmDelete}
                                className="bg-red-600 text-white px-4 py-2 rounded-md hover:bg-red-700"
                            >
                                {loadingDelete ? "در حال حذف..." : "بله، حذف کن"}
                            </button>
                            <button
                                onClick={() => setShowModal(false)}
                                className="bg-gray-300 text-gray-800 px-4 py-2 rounded-md hover:bg-gray-400"
                            >
                                انصراف
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {/* Modal ویرایش شماره */}
            {showEditModal && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-6 w-96 text-center shadow-lg">
                        <p className="mb-4">ویرایش شماره تلفن کاربر {selectedUser?.full_name || "نامشخص"}</p>
                        <input
                            type="text"
                            dir="ltr"
                            inputMode="numeric"
                            value={newNumber}
                            onChange={(e) => {
                                const onlyDigits = e.target.value.replace(/\D/g, '');
                                if (onlyDigits.length <= 11) {
                                    setNewNumber(onlyDigits);
                                }
                            }}
                            className="border rounded px-3 py-2 w-full mb-4 text-center"
                            placeholder="شماره جدید را وارد کنید"
                        />
                        <div className="flex justify-around">
                            <button
                                onClick={confirmEdit}
                                className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700"
                            >
                                {loadingEdit ? "در حال ذخیره..." : "ذخیره تغییرات"}
                            </button>
                            <button
                                onClick={() => setShowEditModal(false)}
                                className="bg-gray-300 text-gray-800 px-4 py-2 rounded-md hover:bg-gray-400"
                            >
                                انصراف
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {/* modal افزودن */}
            {add && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-6 w-96 text-center shadow-lg">
                        <p className="mb-4 text-lg font-semibold">افزودن کاربر جدید</p>

                        <input
                            type="text"
                            value={selectedUser?.full_name || ''}
                            onChange={(e) => {
                                const value = e.target.value;
                                setSelectedUser((prev) => ({ ...(prev || {}), full_name: value }));
                            }}
                            className="border rounded px-3 py-2 w-full mb-3 text-center"
                            placeholder="نام و نام خانوادگی"
                        />

                        <input
                            type="text"
                            dir="ltr"
                            inputMode="numeric"
                            value={newNumber}
                            onChange={(e) => {
                                const onlyDigits = e.target.value.replace(/\D/g, '');
                                if (onlyDigits.length <= 11) {
                                    setNewNumber(onlyDigits);
                                }
                            }}
                            className="border rounded px-3 py-2 w-full mb-3 text-center"
                            placeholder="شماره موبایل"
                        />

                        <input
                            type="text"
                            dir="ltr"
                            inputMode="numeric"
                            value={selectedUser?.national_code || ''}
                            onChange={(e) => {
                                const onlyDigits = e.target.value.replace(/\D/g, '');
                                if (onlyDigits.length <= 10) {
                                    setSelectedUser((prev) => ({ ...(prev || {}), national_code: onlyDigits }));
                                }
                            }}
                            className="border rounded px-3 py-2 w-full mb-4 text-center"
                            placeholder="کد ملی"
                        />

                        <div className="flex justify-around">
                            <button
                                onClick={() => {
                                    addUser()
                                }}
                                className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700"
                            >
                                {loadingEdit ? "در حال افزودن..." : "افزودن"}
                            </button>
                            <button
                                onClick={() => {
                                    setAdd('');
                                    setNewNumber('');
                                    setSelectedUser(null);
                                }}
                                className="bg-gray-300 text-gray-800 px-4 py-2 rounded-md hover:bg-gray-400"
                            >
                                انصراف
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
